import type { SpinWheelOfWinnersResponse, WheelSectionDetails, SectionType } from 'src/store/modules/bonusesFlow/types'
import type { TypedThunk } from 'store/types'

type SpinWheelOfWinnersRequest = {
  type: 'SpinWheelOfWinnersRequest'
  code: string
}

// const apiMock = {
//   spinWheelOfWinners: async (...args: any): Promise<SpinWheelOfWinnersResponse> => {
//     console.log('SpinWheelOfWinnersRequest start')
//     await new Promise((res) => setTimeout(res, 1000))
//     console.log('SpinWheelOfWinnersRequest end')

//     return {
//       type: 'SpinWheelOfWinnersResponse',
//       sectionCode: 's3',
//       // nextSpinAt: null,
//       nextSpinAt: '2024-10-22T16:34:51.681Z',
//     }
//   },
// }

const getSpinWheelOfWinners =
  (
    code: string,
    cb: (state: {
      sectionCode?: string
      nextSpinAt?: string
      messageKey?: string
      details?: WheelSectionDetails
      sectionType?: SectionType
      loading?: boolean
    }) => void,
  ): TypedThunk =>
  (dispatch, getState, { api, errorHandler }) => {
    const data: SpinWheelOfWinnersRequest = {
      type: 'SpinWheelOfWinnersRequest',
      code,
    }

    api
      .spinWheelOfWinners(data)
      .then((body) => {
        const { sectionCode, nextSpinAt, sectionType, messageKey, details } = body as SpinWheelOfWinnersResponse

        if (sectionCode) {
          cb({ sectionCode, nextSpinAt, sectionType, messageKey, details, loading: false })
        } else {
          throw {
            status: {
              errorText: 'Something went wrong',
            },
          }
        }
      })
      .catch((err) => {
        cb({ loading: false })
        dispatch(errorHandler(err, data))
      })
  }

export default getSpinWheelOfWinners
